export default __webpack_public_path__ + "static/175-large-us-marketing-teams-a1fb9dea277ff1b376d1e5db6ed16109.png";